import { usePutProbeStockApi } from 'api/probe_stock'
import { Flex } from 'components/shared/flex'
import { DateField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { ProbeStock, ProbeStockForm } from 'entities/probe_stock'

const FormView = (form: Form<ProbeStockForm>, apiError: ApiError) => {
    return (
        <>
            <Flex alignItems="flex-end">
                <DateField apiError={apiError} form={form} attr={'openedDate'} label="開封日" />
                <Button
                    style={{ width: 130, marginBottom: 20 }}
                    size="sm"
                    variant="secondary"
                    onClick={() => {
                        form.updateObject('openedDate', null)
                    }}
                >
                    リセット
                </Button>
            </Flex>
            <Flex alignItems="flex-end">
                <DateField apiError={apiError} form={form} attr={'usedDate'} label="使い切った日" />
                <Button
                    style={{ width: 130, marginBottom: 20 }}
                    size="sm"
                    variant="secondary"
                    onClick={() => {
                        form.updateObject('usedDate', null)
                    }}
                >
                    リセット
                </Button>
            </Flex>
        </>
    )
}

type EditProbeStockFormProps = {
    probeStock: ProbeStock
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditProbeStockForm = (props: EditProbeStockFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutProbeStockApi()
    const form = useForm<ProbeStockForm>(props.probeStock)

    useEffectSkipFirst(() => {
        form.set(props.probeStock)
    }, [props.probeStock])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>在庫の編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <>{FormView(form, api.apiError)}</>}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
